import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'user-playlist',
  templateUrl: './user-playlist.template.html',
  styleUrls: ['./user-playlist.style.scss']
})
export class UserPlaylist implements OnInit {

  @Input() playlist: any;
  @Input() updated; 

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/user-playlist/user-playlist.component.ts